<template>
	<div class='collapse-component'>
		<div :style='{height: currentHeight, overflow: overflow}'>
			<div ref='slot'>
				<slot></slot>
			</div>
		</div>
		<div v-show='showIcon' class="collapseIcon" @click="collapseClick">
			<i v-show='isCollapse' class="el-icon-arrow-down"></i>
			<i v-show='!isCollapse' class="el-icon-arrow-up"></i>
		</div>
	</div>
</template>

<script type="text/babel">
  import { mapState,mapActions } from 'vuex';
	//允许浮动的值
	const num = 10
	
	export default {
		data() {
			return {
				isCollapse: true,
				showIcon: true
			}
		},
		props: {
			height: {
				type: [String, Number],
				default() {
					return 40
				}
			}
		},
    watch:{
      updateCollapse(){
        if(this.updateCollapse){
          this.$nextTick(() => {
            this.showIcon = this.height + num < this.$refs.slot.clientHeight
            this.commitCollapseUpdate(false)
          })
        }
      }
    },
		computed: {
      ...mapState({
        updateCollapse: state => state.updateCollapse
      }),
			currentHeight() {
				return this.isCollapse ? this.height + 'px' : 'auto'
			},
			overflow() {
				return this.isCollapse ? 'hidden' : 'auto'
			}
		},
		mounted() {
			this.showIcon = this.height + num < this.$refs.slot.clientHeight
		},
		methods: {
      ...mapActions([
        'commitCollapseUpdate'
      ]),
			collapseClick() {
				this.isCollapse = !this.isCollapse
				this.$emit('collapse-change')
			}
		}
	}
</script>

<style lang="less" scoped>
	.collapseIcon {
		text-align: center;
	}
</style>